/**
 * Download data as csv
 * @param title
 * @param csvData
 */
const useDownloadCSVData = (title: string, csvData: any[]) => {
  const handleDownload = () => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([csvData.join('\n')], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = `${title}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return { handleDownload };
};

export default useDownloadCSVData;
